import { css, cx } from 'emotion';
import {
	grey,
	lightGrey,
	headingMediumLight,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

const padding = 24;

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
});

export const metaAudiencesStyle = css({
	marginBottom: '20px',
	'& span:not(:last-child)': {
		marginRight: '8px',
	},
});

export const attributeStyle = color =>
	css({
		display: 'block',
		marginTop: '6px',
		'& span': {
			fontSize: '16px',
			lineHeight: '19px',
			background: color,
			color: '#fff',
			borderRadius: '18px',
			padding: '6px 12px',
			whiteSpace: 'nowrap',
			display: 'inline-block',
		},
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			display: 'inline-block',
			'&:not(:first-child)': {
				marginLeft: '6px',
			},
		},
	});

export const titleStyle = cx(
	headingMediumLight,
	css({
		marginTop: '12px',
		marginBottom: '4px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
			lineHeight: '17px',
		},
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			marginTop: '0',
		},
	})
);

export const subTitleStyle = css({
	fontSize: '14px',
	lineHeight: '15px',
	marginTop: '0',
	marginBottom: '14px',
	color: grey,
});

export const bodyStyle = css({
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		marginLeft: '30px',
	},
});

export const wrapperStyle = css({
	position: 'relative',
	textDecoration: 'none',
	borderRadius: '6px',
	width: '100%',
	height: '100%',
	padding: `${padding}px 0 ${padding}px ${padding}px`,
	backgroundColor: '#fff',
	boxSizing: 'border-box',
	zIndex: '1',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: `14px 14px 36px 14px`,
	},
	display: 'flex',
	flexFlow: 'column',
	alignItems: 'center',
	textAlign: 'center',
	alignContent: 'center',

	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		textAlign: 'left',
		flexFlow: 'row',
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/treatmentServiceMapCard/styles.js